
// Product variant radio button accessibility
document.addEventListener('click', function (e) {
  const radio = e.target.closest('.product__chip[role="radio"]');
  if (!radio) return;

  const group = radio.closest('[role="radiogroup"]');
  if (!group) return;

  const radios = group.querySelectorAll('[role="radio"]');

  radios.forEach(btn => {
    btn.classList.remove('selected');
    btn.setAttribute('aria-checked', 'false');
    btn.setAttribute('tabindex', '-1');
  });

  radio.classList.add('selected');
  radio.setAttribute('aria-checked', 'true');
  radio.setAttribute('tabindex', '0');
});

document.addEventListener('keydown', function (e) {
  if (!e.target.matches('[role="radio"]')) return;

  const group = e.target.closest('[role="radiogroup"]');
  const radios = Array.from(group.querySelectorAll('[role="radio"]'));
  let index = radios.indexOf(e.target);

  if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
    index = (index + 1) % radios.length;
  } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
    index = (index - 1 + radios.length) % radios.length;
  } else {
    return;
  }

  radios[index].click();
  radios[index].focus();
  e.preventDefault();
});

// Heading cleanup for empty loading indicators
document.addEventListener('DOMContentLoaded', function () {
  const heading = document.querySelector('.quick-view-modal-loading-indicator');

  if (heading && heading.textContent.trim() === '') {
    heading.remove();
  }
});

// adding accessible aria-labels to image with text sections
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const sections = document.querySelectorAll('.image-with-text__text-container-inner');

    sections.forEach(function (section) {
      const heading = section.querySelector('.image-with-text__text-container-heading');
      const anchor = section.querySelector('a.btn.btn--overlay.btn--primary');

      if (!heading || !anchor) return;

      const headingText = heading.textContent.trim();
      const anchorText = anchor.textContent.trim();

      if (headingText && anchorText) {
        anchor.setAttribute('aria-label', `${anchorText}, ${headingText}`);
      }
    });
  }, 500); 
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const sections = document.querySelectorAll('.image-with-text__text-container-inner');

    sections.forEach(function (section) {
      const heading = section.querySelector('.image-with-text__text-container-heading');
      const anchor = section.querySelector('a.btn.btn--overlay.btn--primary');

      if (!heading || !anchor) return;

      const headingText = heading.textContent.trim();
      const anchorText = anchor.textContent.trim();

      if (headingText && anchorText) {
        anchor.setAttribute('aria-label', `${anchorText}, ${headingText}`);
      }
    });
  }, 500); 
});

document.addEventListener('DOMContentLoaded', function () {
  const articles = document.querySelectorAll('.article-item__content-inner');

  articles.forEach(function (article) {
    const heading = article.querySelector('.article-item__title a');
    const anchor = article.querySelector('.article-item__read-button a');

    if (!heading || !anchor) return;

    const headingText = heading.textContent.trim();
    const anchorText = anchor.textContent.trim();

    if (headingText && anchorText) {
      anchor.setAttribute('aria-label', `${anchorText}, ${headingText}`);
    }
  });
});

// External links accessibility
  document.addEventListener('DOMContentLoaded', () => {
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');

    const excludedLinks = [
      'https://www.facebook.com/',
      'https://www.instagram.com/',
      'https://www.tiktok.com/'
    ];

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');

      // Set aria-label
      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, This link will open in a new tab`;
      link.setAttribute('aria-label', ariaLabel);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  handleExternalLinks();
});

// Email and phone number labels
document.addEventListener('DOMContentLoaded', () => {
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  handleContactLinks();
});

// Basic HTML tag accessibility
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('br, b').forEach(element => {
      element.setAttribute('aria-hidden', 'true');
    });
});

// Heading level 6 cleanup
document.querySelectorAll('h6').forEach(h6 => {
  // Check if the h6 is empty or only contains a <br>
  if (!h6.textContent.trim() && h6.querySelectorAll('br').length) {
    h6.remove();
  }
});

// click base menu and submenu
$(document).ready(function () {

  const ACTIVE = "active";

  // 🔹 REMOVE ALL THEME EVENTS
  $(".navigation__submenu-trigger").each(function () {
    const $old = $(this);
    const $new = $old.clone(false);
    $old.replaceWith($new);
  });

  // 🔹 FUNCTION TOGGLE SUBMENU
  function toggleMenu($trigger) {
    const $submenu = $("#" + $trigger.attr("aria-controls"));
    const isOpen = $submenu.hasClass(ACTIVE);

    // Close all
    $(".navigation__submenu")
      .removeClass(ACTIVE)
      .hide()
      .attr("aria-hidden", "true");

    $(".navigation__submenu-trigger")
      .attr("aria-expanded", "false");

    // Open current
    if (!isOpen) {
      $submenu
        .addClass(ACTIVE)
        .show()
        .attr("aria-hidden", "false");

      $trigger.attr("aria-expanded", "true");

      // Keep focus on clicked button
      setTimeout(() => {
        $trigger.focus();
      }, 0);
    }
  }

  // 🔹 CLICK BASED TOGGLE (MOUSE + TOUCH)
  $(document).on("click", ".navigation__submenu-trigger", function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggleMenu($(this));
  });

  // 🔹 KEYBOARD ENTER / SPACE
  $(document).on("keydown", ".navigation__submenu-trigger", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu($(this));
    }
  });

  // 🔹 OUTSIDE CLICK CLOSE
  $(document).on("click", function (e) {
    if (!$(e.target).closest("[data-submenu-parent]").length) {
      $(".navigation__submenu")
        .removeClass(ACTIVE)
        .hide()
        .attr("aria-hidden", "true");

      $(".navigation__submenu-trigger")
        .attr("aria-expanded", "false");
    }
  });

  // 🔹 REMOVE ARIA-EXPANDED FROM NON-SUBMENU LINKS
  function cleanNonSubmenuLinks() {
    $(".header__links-list li:not([data-submenu-parent]) > a")
      .removeAttr("aria-expanded");
  }
  cleanNonSubmenuLinks();

  // 🔹 OBSERVER FOR DYNAMIC LINKS
  const targetNode = document.querySelector(".header__links-list");
  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          cleanNonSubmenuLinks();
        }
      });
    });
    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }
});

// svg accessibility - hide from screen readers
$(document).ready(function () {
    $("svg").each(function () {
        const hasTitle = $(this).find("title").length > 0;
        const hasAriaLabel = $(this).attr("aria-label");
        const hasAriaLabelledBy = $(this).attr("aria-labelledby");
        const isImageRole = $(this).attr("role") === "img";

        if (!hasTitle && !hasAriaLabel && !hasAriaLabelledBy && !isImageRole) {
            $(this).attr("aria-hidden", "true");
        }
    });
});

// mobile menu focus management 
$(document).ready(function () {
  let lastShopAllTrigger = null;

  /* SHOP ALL CLICK → MOVE FOCUS TO EXIT */
  $(document).on('click', '.drawer-menu__link[data-item="parent"]', function (e) {
    e.preventDefault();

    lastShopAllTrigger = $(this);

    const $submenu = $(this).next('.drawer-menu__list--sub');

    // aria updates (optional but recommended)
    $(this).attr('aria-expanded', 'true');
    $submenu.attr('aria-hidden', 'false').addClass('visible');

    // wait for animation
    setTimeout(function () {
      const $exitBtn = $submenu.find('[data-item="back"]');

      if ($exitBtn.length) {
        $exitBtn.attr('tabindex', '0').focus();
      }
    }, 250);
  });

  /* EXIT / BACK CLICK → RETURN FOCUS TO SHOP ALL */
  $(document).on('click', '[data-item="back"]', function () {
    const $submenu = $(this).closest('.drawer-menu__list--sub');

    $submenu.removeClass('visible').attr('aria-hidden', 'true');

    if (lastShopAllTrigger) {
      lastShopAllTrigger.attr('aria-expanded', 'false');

      setTimeout(function () {
        lastShopAllTrigger.focus();
      }, 150);
    }
  });
});

  $(document).ready(function() {
    $('#close-navigation-button').on('click', function() {

      // Remove active and visible classes from drawer menu
      $('.drawer-menu').removeClass('active visible');

      // Target the menu button
      var $menuButton = $('button.header__menu-icon.header__icon-touch.header__icon-menu');

      // Set aria-expanded to false
      $menuButton.attr('aria-expanded', 'false');
      $menuButton.attr('aria-label', 'Open menu modal');


      // After 1 second, focus the menu button
      setTimeout(function() {
        $menuButton.focus();
      }, 1000);

    });
  });


let lastFocusedElement = null;

// Call this when opening the cart drawer
function openCartDrawer(openButton) {
  lastFocusedElement = openButton;

  const drawer = document.querySelector(".quick-cart__wrapper");
  drawer.classList.add("active");
  drawer.focus();
}

// Close function
function closeCartDrawer() {
  const drawer = document.querySelector(".quick-cart__wrapper");

  drawer.classList.remove("active");

  // Return focus to the button that opened the drawer
  if (lastFocusedElement) {
    lastFocusedElement.focus();
  }
}

// Escape key handler
document.addEventListener("keydown", (event) => {
  const drawer = document.querySelector(".quick-cart__wrapper");

  if (
    event.key === "Escape" &&
    drawer.classList.contains("active")
  ) {
    closeCartDrawer();
  }
});

// Optional: close on close button click
document.addEventListener("click", (event) => {
  if (event.target.closest(".quick-cart__close-icon")) {
    closeCartDrawer();
  }
});
